import { Config } from "../config";

export const isNotDev = () => window.location.hostname !== 'localhost';

export const isNotProd = () => !isNotDev() || Config.StageName !== 'beta';

export const isProd = () => isNotDev() && Config.StageName === 'beta';

export const isStaging = () => isNotDev() && Config.StageName === 'staging';

export const isTest = () => isNotDev() && Config.StageName === 'test';

export const isEUprod = () => isNotDev() && Config.StageName === 'eupilot';
